module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-iphone-60x60-18506629008b08c48286bb6ad2064e8b.png";